import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import HeaderPrimeButtonComponent from "~/components/acquisition/HeaderPrimeButton";
import withPrimeContext from "../withPrimeContext";

export default withPrimeContext(
  withErrorBoundary(HeaderPrimeButtonComponent, {
    name: "HeaderPrimeButtonComponent",
  }),
);
